export const snugHelpEmail = 'help@snug.com'

// Text
export const textNotAvailableShort = 'N/A'
